

// // public/src/pages/Projects.jsx
// import React, { useState, useEffect } from "react";
// import { motion } from "framer-motion";
// import { Link } from "react-router-dom";
// import {
//   FiFilter,
//   FiSearch,
//   FiArrowRight,
//   FiMapPin,
//   FiCalendar,
//   FiGrid,
// } from "react-icons/fi";
// import axios from "axios";

// function Projects() {
//   const [projects, setProjects] = useState([]);
//   const [filteredProjects, setFilteredProjects] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState("all");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchProjects();
//   }, []);

//   useEffect(() => {
//     filterProjects();
//   }, [projects, selectedCategory, searchTerm]);

//   const fetchProjects = async () => {
//     try {
//       const response = await axios.get(
//         "https://agri-back-mauve.vercel.app/api/content/public/project"
//       );
//       if (response.data.success) {
//         const projectsData = response.data.data;
//         setProjects(projectsData);

//         // Extract unique categories safely
//         const uniqueCategories = [
//           ...new Set(
//             projectsData
//               .map((project) => project.category)
//               .filter((category) => category) // Remove undefined/null
//           ),
//         ];
//         setCategories(uniqueCategories);
//       }
//     } catch (error) {
//       console.error("Error fetching projects:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const filterProjects = () => {
//     let filtered = projects;

//     if (selectedCategory !== "all") {
//       filtered = filtered.filter(
//         (project) => project.category === selectedCategory
//       );
//     }

//     if (searchTerm) {
//       filtered = filtered.filter(
//         (project) =>
//           project.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           project.client.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           project.description.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }

//     setFilteredProjects(filtered);
//   };

//   const getStatusColor = (status) => {
//     switch (status) {
//       case "completed":
//         return "bg-green-100 text-green-800 border-green-200";
//       case "ongoing":
//         return "bg-blue-100 text-blue-800 border-blue-200";
//       case "upcoming":
//         return "bg-yellow-100 text-yellow-800 border-yellow-200";
//       default:
//         return "bg-gray-100 text-gray-800 border-gray-200";
//     }
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gradient-to-b from-gray-50 to-green-50 flex items-center justify-center">
//         <div className="text-center">
//           <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
//           <p className="text-green-700 font-semibold">Loading projects...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="projects-page min-h-screen bg-gradient-to-b from-gray-50 to-green-50">
//       {/* Hero Section */}
//       <section className="page-hero bg-gradient-to-r from-green-900 to-emerald-800 text-white py-20">
//         <div className="container mx-auto px-4 sm:px-6 lg:px-8">
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.7 }}
//             className="text-center max-w-4xl mx-auto"
//           >
//             <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">
//               Our Projects
//             </h1>
//             <p className="text-xl md:text-2xl text-gray-200 leading-relaxed">
//               Discover how we're transforming agriculture across Africa with
//               innovative technology solutions
//             </p>
//           </motion.div>
//         </div>
//       </section>

//       {/* Filters Section */}
//       <section className="filters-section py-8 bg-white/80 backdrop-blur-sm border-b border-green-100 sticky top-0 z-10">
//         <div className="container mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="filters-container flex flex-col lg:flex-row gap-6 items-center justify-between">
//             {/* Search Box */}
//             <div className="search-box relative w-full lg:w-96">
//               <div className="relative">
//                 <FiSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-green-600 w-5 h-5" />
//                 <input
//                   type="text"
//                   placeholder="Search projects by title, client, or description..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   className="w-full pl-12 pr-6 py-4 bg-white border border-green-200 rounded-2xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300 text-gray-700 placeholder-green-400 shadow-sm hover:shadow-md"
//                 />
//               </div>
//             </div>

//             {/* Category Filters */}
//             <div className="category-filters flex flex-wrap gap-3 justify-center">
//               <motion.button
//                 whileHover={{ scale: 1.05 }}
//                 whileTap={{ scale: 0.95 }}
//                 className={`filter-btn px-6 py-3 rounded-2xl font-semibold transition-all duration-300 flex items-center gap-2 ${
//                   selectedCategory === "all"
//                     ? "bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-lg shadow-green-200"
//                     : "bg-white text-green-700 border border-green-200 hover:border-green-400 hover:shadow-md"
//                 }`}
//                 onClick={() => setSelectedCategory("all")}
//               >
//                 <FiGrid className="w-4 h-4" />
//                 All Projects
//               </motion.button>
//               {categories.map((category) => (
//                 <motion.button
//                   key={category}
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.95 }}
//                   className={`filter-btn px-6 py-3 rounded-2xl font-semibold transition-all duration-300 ${
//                     selectedCategory === category
//                       ? "bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-lg shadow-green-200"
//                       : "bg-white text-green-700 border border-green-200 hover:border-green-400 hover:shadow-md"
//                   }`}
//                   onClick={() => setSelectedCategory(category)}
//                 >
//                   {category}
//                 </motion.button>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Projects Grid */}
//       <section className="projects-grid-section py-16">
//         <div className="container mx-auto px-4 sm:px-6 lg:px-8">
//           {filteredProjects.length === 0 ? (
//             <motion.div
//               initial={{ opacity: 0, scale: 0.9 }}
//               animate={{ opacity: 1, scale: 1 }}
//               className="no-results text-center py-16"
//             >
//               <div className="max-w-md mx-auto">
//                 <div className="w-24 h-24 mx-auto mb-6 bg-green-100 rounded-full flex items-center justify-center">
//                   <FiSearch className="w-12 h-12 text-green-600" />
//                 </div>
//                 <h3 className="text-2xl font-bold text-gray-700 mb-3">
//                   No projects found
//                 </h3>
//                 <p className="text-gray-500 mb-6">
//                   Try adjusting your search or filters to find what you're
//                   looking for.
//                 </p>
//                 <button
//                   onClick={() => {
//                     setSearchTerm("");
//                     setSelectedCategory("all");
//                   }}
//                   className="px-6 py-3 bg-green-600 text-white rounded-2xl hover:bg-green-700 transition-colors duration-300 font-semibold"
//                 >
//                   Reset Filters
//                 </button>
//               </div>
//             </motion.div>
//           ) : (
//             <>
//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 className="results-info mb-8 text-center"
//               >
//                 <p className="text-green-700 font-semibold">
//                   Showing {filteredProjects.length} project
//                   {filteredProjects.length !== 1 ? "s" : ""}
//                   {selectedCategory !== "all" && ` in ${selectedCategory}`}
//                 </p>
//               </motion.div>

//               <div className="projects-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//                 {filteredProjects.map((project, index) => (
//                   <motion.div
//                     key={project._id}
//                     initial={{ opacity: 0, y: 30 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     transition={{ delay: index * 0.1 }}
//                     whileHover={{ y: -8, scale: 1.02 }}
//                     className="project-card group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-green-100 flex flex-col h-full"
//                   >
//                     {/* Project Image */}
//                     {project.image && (
//                       <div className="project-image relative h-48 overflow-hidden">
//                         <img
//                           src={
//                             project.image.startsWith("http")
//                               ? project.image
//                               : `https://agri-back-mauve.vercel.app${project.image}`
//                           }
//                           alt={project.title}
//                           className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
//                         />
//                         <div className="project-status absolute top-4 right-4">
//                           <span
//                             className={`status-badge px-3 py-1 rounded-full text-xs font-semibold border ${getStatusColor(
//                               project.project?.status || project.status
//                             )}`}
//                           >
//                             {project.project?.status || project.status}
//                           </span>
//                         </div>
//                         <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
//                       </div>
//                     )}

//                     {/* Project Content */}
//                     <div className="project-content p-6 flex-1 flex flex-col">
//                       <div className="flex items-start justify-between mb-3">
//                         <span className="project-category px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm font-semibold">
//                           {project.category}
//                         </span>
//                       </div>

//                       <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-green-700 transition-colors duration-300 line-clamp-2">
//                         {project.title}
//                       </h3>

//                       <p className="project-client text-green-600 font-semibold mb-3">
//                         {project.client}
//                       </p>

//                       <p className="project-description text-gray-600 leading-relaxed mb-4 line-clamp-3 flex-1">
//                         {project.description}
//                       </p>

//                       {/* Project Meta */}
//                       <div className="project-meta flex flex-col gap-2 mb-4">
//                         <div className="meta-item flex items-center gap-2 text-sm text-gray-500">
//                           <FiMapPin className="w-4 h-4 text-green-500" />
//                           <span className="line-clamp-1">
//                             {project.location}
//                           </span>
//                         </div>
//                         <div className="meta-item flex items-center gap-2 text-sm text-gray-500">
//                           <FiCalendar className="w-4 h-4 text-green-500" />
//                           <span>{project.duration}</span>
//                         </div>
//                       </div>

//                       {/* Technologies */}
//                       {project.technologies &&
//                         project.technologies.length > 0 && (
//                           <div className="project-technologies flex flex-wrap gap-2 mb-4">
//                             {project.technologies.slice(0, 3).map((tech, i) => (
//                               <span
//                                 key={i}
//                                 className="tech-tag px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs font-medium border border-gray-200"
//                               >
//                                 {tech}
//                               </span>
//                             ))}
//                             {project.technologies.length > 3 && (
//                               <span className="tech-tag px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium">
//                                 +{project.technologies.length - 3}
//                               </span>
//                             )}
//                           </div>
//                         )}

//                       {/* Footer */}
//                       <div className="project-footer mt-auto pt-4 border-t border-gray-100">
//                         <Link
//                           to={`/projects/${project._id}`}
//                           className="project-link inline-flex items-center gap-2 px-6 py-3 bg-green-500 text-white rounded-2xl font-semibold hover:bg-green-600 transition-all duration-300 shadow-md hover:shadow-lg w-full justify-center"
//                         >
//                           View Case Study
//                           <FiArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
//                         </Link>
//                       </div>
//                     </div>
//                   </motion.div>
//                 ))}
//               </div>
//             </>
//           )}
//         </div>
//       </section>

//       {/* CTA Section */}
//       <section className="projects-cta py-20 bg-gradient-to-r from-green-900 to-emerald-800">
//         <div className="container mx-auto px-4 sm:px-6 lg:px-8">
//           <motion.div
//             initial={{ opacity: 0, scale: 0.9 }}
//             whileInView={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 0.7 }}
//             className="cta-content text-center max-w-4xl mx-auto"
//           >
//             <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
//               Ready to Start Your Project?
//             </h2>
//             <p className="text-xl text-green-200 mb-8 leading-relaxed">
//               Let's work together to transform your agricultural operations with
//               cutting-edge technology
//             </p>
//             <div className="cta-buttons flex flex-col sm:flex-row gap-4 justify-center">
//               <Link
//                 to="/contact"
//                 className="cta-button primary inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-2xl font-bold text-lg hover:from-green-600 hover:to-emerald-600 transition-all duration-300 shadow-lg hover:shadow-xl"
//               >
//                 Start Your Project
//               </Link>
//               <Link
//                 to="/services"
//                 className="cta-button secondary inline-flex items-center justify-center px-8 py-4 bg-white text-green-700 rounded-2xl font-bold text-lg hover:bg-green-50 transition-all duration-300 border border-transparent hover:border-green-200"
//               >
//                 Explore Our Services
//               </Link>
//             </div>
//           </motion.div>
//         </div>
//       </section>
//     </div>
//   );
// }

// export default Projects;


// public/src/pages/Projects.jsx - UPDATED WITH DARK MODE & PROFESSIONAL STYLING
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  FiFilter,
  FiSearch,
  FiArrowRight,
  FiMapPin,
  FiCalendar,
  FiGrid,
  FiUsers,
  FiTarget,
} from "react-icons/fi";
import axios from "axios";

function Projects() {
  const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProjects();
  }, []);

  useEffect(() => {
    filterProjects();
  }, [projects, selectedCategory, searchTerm]);

  const fetchProjects = async () => {
    try {
      const response = await axios.get(
        "https://agri-back-mauve.vercel.app/api/content/public/project"
      );
      if (response.data.success) {
        const projectsData = response.data.data;
        setProjects(projectsData);

        // Extract unique categories safely
        const uniqueCategories = [
          ...new Set(
            projectsData
              .map((project) => project.category)
              .filter((category) => category)
          ),
        ];
        setCategories(uniqueCategories);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      setLoading(false);
    }
  };

  const filterProjects = () => {
    let filtered = projects;

    if (selectedCategory !== "all") {
      filtered = filtered.filter(
        (project) => project.category === selectedCategory
      );
    }

    if (searchTerm) {
      filtered = filtered.filter(
        (project) =>
          project.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          project.client?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          project.description?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredProjects(filtered);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "completed":
        return "bg-green-100 text-green-800 border-green-200 dark:bg-green-900/30 dark:text-green-300 dark:border-green-800";
      case "ongoing":
        return "bg-blue-100 text-blue-800 border-blue-200 dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-800";
      case "upcoming":
        return "bg-yellow-100 text-yellow-800 border-yellow-200 dark:bg-yellow-900/30 dark:text-yellow-300 dark:border-yellow-800";
      default:
        return "bg-gray-100 text-gray-800 border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-700";
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-green-50 dark:from-gray-900 dark:to-green-900 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-green-700 dark:text-green-300 font-semibold">Loading projects...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="projects-page min-h-screen bg-gradient-to-b from-gray-50 to-green-50 dark:from-gray-900 dark:to-green-900">
      {/* Hero Section */}
      <section className="page-hero bg-gradient-to-r from-green-900 to-emerald-800 text-white py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-green-400 to-emerald-400 bg-clip-text text-transparent">
              Our Projects
            </h1>
            <p className="text-xl md:text-2xl text-gray-200 leading-relaxed">
              Discover how we're transforming agriculture across Africa with innovative technology solutions and sustainable practices.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Filters Section */}
      <section className="filters-section py-8 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm border-b border-green-100 dark:border-green-800 sticky top-0 z-10">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="filters-container flex flex-col lg:flex-row gap-6 items-center justify-between">
            {/* Search Box */}
            <div className="search-box relative w-full lg:w-96">
              <div className="relative">
                <FiSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-green-600 dark:text-green-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="Search projects by title, client, or description..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-12 pr-6 py-4 bg-white dark:bg-gray-700 border border-green-200 dark:border-green-600 rounded-2xl focus:ring-2 focus:ring-green-500 focus:border-transparent transition-all duration-300 text-gray-700 dark:text-gray-200 placeholder-green-400 dark:placeholder-green-300 shadow-sm hover:shadow-md dark:shadow-gray-900"
                />
              </div>
            </div>

            {/* Category Filters */}
            <div className="category-filters flex flex-wrap gap-3 justify-center">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className={`filter-btn px-6 py-3 rounded-2xl font-semibold transition-all duration-300 flex items-center gap-2 ${
                  selectedCategory === "all"
                    ? "bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-lg shadow-green-200 dark:shadow-green-900"
                    : "bg-white dark:bg-gray-700 text-green-700 dark:text-green-300 border border-green-200 dark:border-green-600 hover:border-green-400 dark:hover:border-green-400 hover:shadow-md"
                }`}
                onClick={() => setSelectedCategory("all")}
              >
                <FiGrid className="w-4 h-4" />
                All Projects
              </motion.button>
              {categories.map((category) => (
                <motion.button
                  key={category}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className={`filter-btn px-6 py-3 rounded-2xl font-semibold transition-all duration-300 ${
                    selectedCategory === category
                      ? "bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-lg shadow-green-200 dark:shadow-green-900"
                      : "bg-white dark:bg-gray-700 text-green-700 dark:text-green-300 border border-green-200 dark:border-green-600 hover:border-green-400 dark:hover:border-green-400 hover:shadow-md"
                  }`}
                  onClick={() => setSelectedCategory(category)}
                >
                  {category}
                </motion.button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="projects-grid-section py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {filteredProjects.length === 0 ? (
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              className="no-results text-center py-16"
            >
              <div className="max-w-md mx-auto">
                <div className="w-24 h-24 mx-auto mb-6 bg-green-100 dark:bg-green-800 rounded-full flex items-center justify-center">
                  <FiSearch className="w-12 h-12 text-green-600 dark:text-green-400" />
                </div>
                <h3 className="text-2xl font-bold text-gray-700 dark:text-gray-300 mb-3">
                  No projects found
                </h3>
                <p className="text-gray-500 dark:text-gray-400 mb-6">
                  Try adjusting your search or filters to find what you're looking for.
                </p>
                <button
                  onClick={() => {
                    setSearchTerm("");
                    setSelectedCategory("all");
                  }}
                  className="px-6 py-3 bg-green-600 text-white rounded-2xl hover:bg-green-700 transition-colors duration-300 font-semibold"
                >
                  Reset Filters
                </button>
              </div>
            </motion.div>
          ) : (
            <>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="results-info mb-8 text-center"
              >
                <p className="text-green-700 dark:text-green-300 font-semibold">
                  Showing {filteredProjects.length} project
                  {filteredProjects.length !== 1 ? "s" : ""}
                  {selectedCategory !== "all" && ` in ${selectedCategory}`}
                </p>
              </motion.div>

              <div className="projects-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {filteredProjects.map((project, index) => (
                  <motion.div
                    key={project._id}
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1 }}
                    whileHover={{ y: -8, scale: 1.02 }}
                    className="project-card group bg-white dark:bg-gray-800 rounded-3xl shadow-lg hover:shadow-2xl dark:shadow-gray-900/50 transition-all duration-500 overflow-hidden border border-green-100 dark:border-green-800 flex flex-col h-full"
                  >
                    {/* Project Image */}
                    {project.image && (
                      <div className="project-image relative h-48 overflow-hidden">
                        <img
                          src={
                            project.image.startsWith("http")
                              ? project.image
                              : `https://agri-back-mauve.vercel.app${project.image}`
                          }
                          alt={project.title}
                          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                        />
                        <div className="project-status absolute top-4 right-4">
                          <span
                            className={`status-badge px-3 py-1 rounded-full text-xs font-semibold border ${getStatusColor(
                              project.project?.status || project.status
                            )}`}
                          >
                            {project.project?.status || project.status}
                          </span>
                        </div>
                        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                      </div>
                    )}

                    {/* Project Content */}
                    <div className="project-content p-6 flex-1 flex flex-col">
                      <div className="flex items-start justify-between mb-3">
                        <span className="project-category px-3 py-1 bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300 rounded-full text-sm font-semibold">
                          {project.category}
                        </span>
                      </div>

                      <h3 className="text-xl font-bold text-gray-800 dark:text-white mb-2 group-hover:text-green-700 dark:group-hover:text-green-400 transition-colors duration-300 line-clamp-2">
                        {project.title}
                      </h3>

                      {project.client && (
                        <div className="project-client flex items-center gap-2 text-green-600 dark:text-green-400 font-semibold mb-3">
                          <FiUsers className="w-4 h-4" />
                          <span>{project.client}</span>
                        </div>
                      )}

                      <p className="project-description text-gray-600 dark:text-gray-300 leading-relaxed mb-4 line-clamp-3 flex-1">
                        {project.description}
                      </p>

                      {/* Project Meta */}
                      <div className="project-meta flex flex-col gap-2 mb-4">
                        {project.location && (
                          <div className="meta-item flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                            <FiMapPin className="w-4 h-4 text-green-500 dark:text-green-400" />
                            <span className="line-clamp-1">
                              {project.location}
                            </span>
                          </div>
                        )}
                        {project.duration && (
                          <div className="meta-item flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                            <FiCalendar className="w-4 h-4 text-green-500 dark:text-green-400" />
                            <span>{project.duration}</span>
                          </div>
                        )}
                      </div>

                      {/* Technologies */}
                      {project.technologies && project.technologies.length > 0 && (
                        <div className="project-technologies flex flex-wrap gap-2 mb-4">
                          {project.technologies.slice(0, 3).map((tech, i) => (
                            <span
                              key={i}
                              className="tech-tag px-3 py-1 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-full text-xs font-medium border border-gray-200 dark:border-gray-600"
                            >
                              {tech}
                            </span>
                          ))}
                          {project.technologies.length > 3 && (
                            <span className="tech-tag px-3 py-1 bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300 rounded-full text-xs font-medium">
                              +{project.technologies.length - 3}
                            </span>
                          )}
                        </div>
                      )}

                      {/* Footer */}
                      <div className="project-footer mt-auto pt-4 border-t border-gray-100 dark:border-gray-700">
                        <Link
                          to={`/projects/${project._id}`}
                          className="project-link inline-flex items-center gap-2 px-6 py-3 bg-green-500 text-white rounded-2xl font-semibold hover:bg-green-600 transition-all duration-300 shadow-md hover:shadow-lg w-full justify-center"
                        >
                          View Case Study
                          <FiArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
                        </Link>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
            </>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="projects-cta py-20 bg-gradient-to-r from-green-900 to-emerald-800">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7 }}
            className="cta-content text-center max-w-4xl mx-auto"
          >
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Ready to Start Your Project?
            </h2>
            <p className="text-xl text-green-200 mb-8 leading-relaxed">
              Let's work together to transform your agricultural operations with cutting-edge technology and sustainable solutions.
            </p>
            <div className="cta-buttons flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="cta-button primary inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-2xl font-bold text-lg hover:from-green-600 hover:to-emerald-600 transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                Start Your Project
              </Link>
              <Link
                to="/services"
                className="cta-button secondary inline-flex items-center justify-center px-8 py-4 bg-white text-green-700 rounded-2xl font-bold text-lg hover:bg-green-50 transition-all duration-300 border border-transparent hover:border-green-200"
              >
                Explore Our Services
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}

export default Projects;